export default "__VITE_ASSET__9758644b__"